var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54123 6.76624C4.77265 6.99766 4.77265 7.37287 4.54123 7.60429C4.30981 7.83571 3.9346 7.83571 3.70318 7.60429L0.740217 4.64133C0.508795 4.40991 0.508795 4.0347 0.740217 3.80328L3.70318 0.840315C3.9346 0.608893 4.30981 0.608893 4.54123 0.840315C4.77265 1.07174 4.77265 1.44695 4.54123 1.67837L2.58989 3.62971H8.56665C10.694 3.62971 12.4185 5.35424 12.4185 7.48156C12.4185 9.60888 10.694 11.3334 8.56665 11.3334H4.7148C4.38752 11.3334 4.12221 11.0681 4.12221 10.7408C4.12221 10.4135 4.38752 10.1482 4.7148 10.1482H8.56665C10.0394 10.1482 11.2333 8.95432 11.2333 7.48156C11.2333 6.0088 10.0394 4.8149 8.56665 4.8149H2.58989L4.54123 6.76624Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.3204aecfc6fb59f4609d35bc0e3ddb5e.svg";
export { ForwardRef as ReactComponent };